import React from "react";
import { useTranslation } from "react-i18next";

// Score banner shown after submitting. result = { score, correctCount,
// total, passed, passMark }.
const QuizResult = ({ result }) => {
  const { t, i18n } = useTranslation();
  const { score, correctCount, total, passed } = result;
  const fmt = (n) =>
    i18n.language === "ar" ? Number(n).toLocaleString("ar-EG") : n;

  return (
    <div
      className={`rounded-xl p-5 border flex flex-col sm:flex-row items-center gap-4 ${
        passed
          ? "border-green-500/40 bg-green-500/10"
          : "border-primary/40 bg-primary/10"
      }`}
    >
      <div
        className={`w-16 h-16 rounded-full flex items-center justify-center text-xl font-bold text-white ${
          passed ? "bg-green-500" : "bg-primary"
        }`}
      >
        {fmt(score)}%
      </div>
      <div className="text-center sm:text-start">
        <p className="text-white font-semibold text-lg">
          {passed ? t("quiz.passed") : t("quiz.failed")}
        </p>
        <p className="text-lightWhite text-sm">
          {t("quiz.your_score")}: {fmt(correctCount)} {t("quiz.of")} {fmt(total)}
        </p>
      </div>
    </div>
  );
};

export default QuizResult;
